/* PRODUCTS */
export const SET_TAGORDER = "SET_TAGORDER"
export const SET_TAGORDER_SUCCESS = "SET_TAGORDER_SUCCESS"
export const SET_TAGORDER_FAIL = "SET_TAGORDER_FAIL"